import React, { useEffect } from "react";
import { GridStack } from "gridstack";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import DMSHeader from "../../DMSHeader/DMSHeader";
import { useTranslation } from "react-i18next";
import CreateBranchForm from "./CreateBranchForm";
import { useLocation } from "react-router-dom";

// Component for rendering create/edit branch details form
const BranchForm = () => {
  const { t } = useTranslation();
  const { state } = useLocation();
  // Extract edit data from navigation state
  let dataForEdit = state?.dataForEdit;

  // Initialize GridStack layout system
  useEffect(() => {
    GridStack.init();
  }, []);

  // Set dynamic header title based on edit mode
  const headerTitle = dataForEdit ? t("Edit Branch details") : t("Add Branch");

  // Define grid layout configuration with header and form components
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 0,
      component: (
        <DMSHeader title={headerTitle} showIconsForback={dataForEdit} />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 12,
      id: 1,
      component: <CreateBranchForm />,
    },
  ];

  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default BranchForm;
